import { NoParams, QueryParameter } from '@deltasierra/frontend-routing-core';
import { AppFrontendRoute } from './app-frontend-route';

export const AppFrontendRoutes = {
    ...AppFrontendRoute,
};
export type AppFrontendRoutes = {
    [AppFrontendRoute.Assets]: {
        [QueryParameter.AssetId]?: string;
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.CollectionId]?: string;
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
    };
    [AppFrontendRoute.Connections]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.Configure]?: string;
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.LocationName]?: string;
        [QueryParameter.PlatformName]?: string;
    };
    [AppFrontendRoute.Dashboard]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
    };
    [AppFrontendRoute.DashboardBrands]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
    };
    [AppFrontendRoute.Logout]: NoParams;
    [AppFrontendRoute.ManageTemplates]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
    };
    [AppFrontendRoute.ManageTemplatesEmail]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.NewTemplate]?: string;
        [QueryParameter.Origin]: string;
        [QueryParameter.TemplateId]: string;
    };
    [AppFrontendRoute.ManageTemplatesMedia]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.NewTemplate]?: string;
        [QueryParameter.TemplateId]: string;
    };
    [AppFrontendRoute.PublishEmail]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.Origin]?: string;
        [QueryParameter.PlannerId]?: string;
        // I don't think this one is correct but leaving it to avoid problems
        [QueryParameter.TemplateContentBuildId]?: string;
        [QueryParameter.TemplateId]?: string;
    };
    [AppFrontendRoute.PublishEmailBuild]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.Origin]?: string;
        [QueryParameter.PlannerId]?: string;
        [QueryParameter.TemplateContentBuildId]?: string;
    };
    [AppFrontendRoute.PublishEmailConfirmation]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.Origin]?: string;
        [QueryParameter.ScheduleFlowId]?: string;
        [QueryParameter.TemplateContentBuildId]?: string;
    };
    [AppFrontendRoute.PublishEmailPreview]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.Origin]?: string;
        [QueryParameter.PlannerId]?: string;
        [QueryParameter.ScheduleFlowId]?: string;
        [QueryParameter.TemplateContentBuildId]?: string;
    };
    [AppFrontendRoute.PublishEmailSchedule]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.Origin]?: string;
        [QueryParameter.PlannerId]?: string;
        [QueryParameter.ScheduleFlowId]?: string;
        [QueryParameter.TemplateContentBuildId]?: string;
    };
    [AppFrontendRoute.PublishMedia]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.Origin]?: string;
        [QueryParameter.PlannerId]?: string;
        // I don't think this one is correct but leaving it to avoid problems
        [QueryParameter.TemplateContentBuildId]?: string;
        [QueryParameter.TemplateId]?: string;
    };
    [AppFrontendRoute.PublishMediaBuild]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.Origin]?: string;
        [QueryParameter.PlannerId]?: string;
        [QueryParameter.TemplateContentBuildId]?: string;
    };
    [AppFrontendRoute.PublishMediaPreview]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.Origin]?: string;
        [QueryParameter.PlannerId]?: string;
        [QueryParameter.TemplateContentBuildId]?: string;
    };
    [AppFrontendRoute.PublishMediaSchedule]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.Origin]?: string;
        [QueryParameter.PlannerId]?: string;
        [QueryParameter.ScheduleFlowId]?: string;
        [QueryParameter.TemplateContentBuildId]?: string;
    };
    [AppFrontendRoute.ReportsTemplates]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
    };
    [AppFrontendRoute.Scheduled]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.ScheduledPlatform]?: string;
        [QueryParameter.ScheduledTab]?: string;
    };
    [AppFrontendRoute.Templates]: {
        [QueryParameter.ClientId]?: string; // If not sent, the clientId will be taken from the session
        [QueryParameter.FilterPlatform]?: string;
        [QueryParameter.FilterTab]?: string;
        [QueryParameter.FilterTemplateCategories]?: string;
        [QueryParameter.LocationId]?: string; // If not sent, the locationId will be taken from the session
        [QueryParameter.PlannerId]?: string;
        [QueryParameter.TemplateContentBuildId]?: string;
    };
};
